var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex items-center gap-2 truncate" },
    _vm._l(_vm.breadcrumbs, function(breadcrumb, idx) {
      return _c(
        "div",
        {
          key: idx,
          staticClass: "flex items-center gap-2",
          class: [
            breadcrumb.truncate
              ? "truncate" +
                (idx + 1 < _vm.breadcrumbs.length ? " max-w-64" : "")
              : "flex-shrink-0"
          ]
        },
        [
          idx > 0
            ? _c("BlTextSubtitle3", {
                staticClass: "text-slate-600 flex-shrink-0",
                attrs: { text: "/" }
              })
            : _vm._e(),
          _vm._v(" "),
          breadcrumb.target
            ? _c(
                "router-link",
                {
                  class: [breadcrumb.truncate ? "truncate" : "flex-shrink-0"],
                  attrs: { to: breadcrumb.target, title: breadcrumb.label }
                },
                [
                  _c("BlTextSubtitle3", {
                    staticClass:
                      "hover:text-slate-800 transition-all duration-300",
                    class: [
                      breadcrumb.truncate ? "truncate" : "flex-shrink-0",
                      idx + 1 < _vm.breadcrumbs.length ? "text-slate-600" : ""
                    ],
                    attrs: { text: breadcrumb.label }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          breadcrumb.action
            ? _c(
                "div",
                {
                  staticClass: "cursor-pointer",
                  class: [breadcrumb.truncate ? "truncate" : "flex-shrink-0"],
                  attrs: { title: breadcrumb.label },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return breadcrumb.action($event)
                    }
                  }
                },
                [
                  _c("BlTextSubtitle3", {
                    staticClass:
                      "hover:text-slate-800 transition-all duration-300",
                    class: [
                      breadcrumb.truncate ? "truncate" : "flex-shrink-0",
                      idx + 1 < _vm.breadcrumbs.length ? "text-slate-600" : ""
                    ],
                    attrs: { text: breadcrumb.label }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77e189b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e189b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlBreadcrumbs.vue
// module id = null
// module chunks = 